import styled from 'styled-components';
export const Container = styled.div `
  font-size: var(--font-size-400);
  color: var(--text-secondary);
  line-height: var(--font-line-height-400);
  padding-top: var(--space-250);

  &:not(:first-child)::before {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background-color: var(--border-primary);
    margin: var(--space-475) 0 var(--space-875) 0;
  }
`;
export const Header = styled.div `
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  line-height: var(--font-line-height-400);
`;
export const InnerContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const Tooltip = styled.div `
  margin-left: var(--space-200);
`;
